import { useState, useEffect } from "react";
import { Sparkles } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const VERSION = "multisport_2026";

const ITEMS = [
  { emoji: "⚽", title: "Football Fantasy is live", body: "Build your XI for Football World Cup 2026" },
  { emoji: "🏏", title: "Cricket continues", body: "All IPL features preserved" },
  { emoji: "🏆", title: "Sport-specific leagues", body: "Football OR cricket leagues, your choice" },
  { emoji: "🎁", title: "Daily Rewards", body: "Claim independently for each sport" },
  { emoji: "👥", title: "Referral bonuses", body: "Now earn for both football and cricket invites" },
];

/**
 * WhatsNewModal — sport-agnostic "What's New in APL — Fantasy Sports" popup.
 * Self-gates on a localStorage version key so it shows once across both sports.
 */
export default function WhatsNewModal() {
  const { user, dbUser } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || !dbUser) return;
    // Brand-new users get the full gameplay tutorial — don't also stack "What's New"
    // on them. Mark it seen so it never pops for this fresh account.
    if (dbUser.has_seen_tutorial === false) {
      localStorage.setItem("apl_whats_new_version", VERSION);
      return;
    }
    if (localStorage.getItem("apl_whats_new_version") !== VERSION) {
      setShow(true);
    }
  }, [user, dbUser]);

  const dismiss = () => {
    localStorage.setItem("apl_whats_new_version", VERSION);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[65] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm" data-testid="whats-new-popup">
      <div className="w-full max-w-sm rounded-2xl border border-slate-700 bg-slate-800 p-5">
        <div className="mb-4 text-center">
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-amber-500 to-orange-500">
            <Sparkles className="text-white" size={24} />
          </div>
          <h2 className="text-lg font-bold text-white">What's New in APL — Fantasy Sports</h2>
          <p className="mt-1 text-xs text-amber-400">Football World Cup 2026 starts June 11</p>
        </div>

        <div className="space-y-2.5">
          {ITEMS.map((it) => (
            <div key={it.title} className="flex items-center gap-3 rounded-xl border border-slate-700/60 bg-slate-900/40 p-2.5">
              <span className="grid h-8 w-8 flex-shrink-0 place-items-center rounded-lg bg-slate-700/60 text-lg">{it.emoji}</span>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-white">{it.title}</p>
                <p className="text-xs text-slate-400">{it.body}</p>
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={dismiss}
          className="mt-4 w-full rounded-xl bg-gradient-to-r from-amber-500 to-orange-500 py-2.5 text-sm font-semibold text-white transition-all hover:opacity-90"
          data-testid="dismiss-whats-new"
        >
          Let's Go!
        </button>
      </div>
    </div>
  );
}
